import RichText from '@commons/components/RichText';
import type { DrupalParagraph } from '@commons/types/drupal';

// Type definition for the RichText paragraph properties.

type Props = DrupalParagraph & {
  body: string;
};

/**
 * RichText paragraph component.
 */

const RichTextParagraph = ({ body }: Props) => {
  return <RichText value={body} />;
};

export default RichTextParagraph;
